var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowPrimary814 = function SvgArrowPrimary814(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2897DB",
    fillRule: "evenodd",
    d: "M.234 13.772a.763.763 0 0 1 0-1.1L6.07 7 .234 1.328a.763.763 0 0 1 0-1.1.816.816 0 0 1 1.132 0l6.4 6.222a.763.763 0 0 1 0 1.1l-6.4 6.222a.816.816 0 0 1-1.132 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowPrimary814;